<template>
    <v-row align="center" class="row--small font-size-14">
        <v-col cols="3" md="2">
            <span v-if="cart.product.type == 'main'">주문수량</span>
            <span v-else-if="cart.product.type == 'option'">[{{ cart.product.optionalNames.toString() }}] : {{ cart.product.optionalValues.toString() }}</span>
            <span v-else-if="cart.product.type == 'addition'">[{{ cart.product.additionValue }}] : {{ cart.product.additionValue }}</span>
        </v-col>
        <v-col cols="9" md="10">
            <v-row class="row--x-small" :class="{ 'justify-end': $vuetify.breakpoint.mobile }">
                <v-col cols="auto">
                    <v-btn @click="cart.quantity--" outlined icon tile color="grey" width="40" height="40"><v-icon>mdi-minus</v-icon></v-btn>
                </v-col>
                <v-col cols="auto">
                    <v-text-field v-model="cart.quantity" outlined icon tile hide-details value="1" class="v-number-field" />
                </v-col>
                <v-col cols="auto">
                    <v-btn @click="cart.quantity++" outlined icon tile color="grey" width="40" height="40"><v-icon>mdi-plus</v-icon></v-btn>
                </v-col>
                <v-col cols="auto">
                    <v-btn v-if="cart.product.type == 'option'" @click="$emit('remove') " outlined icon tile color="grey" width="40" height="40"><v-icon>mdi-close</v-icon></v-btn>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: ["value"],
    data(){
        return {
            cart: this.$props.value,
        }
    },
    watch: {
        cart: {
            deep: true,
            handler(){
                this.$emit("input", this.cart);
            }
        }
    }
}
</script>